import {
    Button,
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormHelperText,
    Grid,
    TextField
} from '@mui/material';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';


const SectionInfo = ({ mall }) => {
    const defaultValues = {
        company_name: mall?.company_name,
        company_name_eng: mall?.company_name_eng,
        ceo: mall?.ceo,
        license_num: mall?.license_num,
        sales_license: mall?.sales_license,
        tel: mall?.tel,
        fax: mall?.fax,
        zip: mall?.zip,
        address: mall?.address,
        coo: mall?.coo,
        coo_email: mall?.coo_email,
        cs_email: mall?.cs_email
    }
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm({})

    useEffect(() => {        
        reset(defaultValues)
    }, [mall])

    const onSubmit = async (data, e) => {
        const params = JSON.stringify({
            "company_name": data.company_name,
            "company_name_eng": data.company_name_eng,
            "ceo": data.ceo,
            "license_num": data.license_num,
            "sales_license": data.sales_license,
            "tel": data.tel,
            "fax": data.fax,
            "zip": data.zip,
            "address": data.address,
            "coo": data.coo,
            "coo_email": data.coo_email,
            "cs_email": data.cs_email
        });

        try {
            await apiService.put('/malls/general', params);
            toast.success('업데이트 되었습니다.');
        } catch (error) {
            console.error(error);
        }
    }

    return (
        mall &&
        <Card>
            <CardHeader title='쇼핑몰 정보' titleTypographyProps={{ variant: 'h6' }} />
            <CardContent>
                <form onSubmit={handleSubmit(onSubmit)} id="mallbizform">
                    <Grid container spacing={6}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='company_name'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='회사명'
                                            id='company_name'
                                            onChange={onChange}
                                            placeholder='회사명를 입력해주세요'
                                            error={Boolean(errors.company_name)}
                                            aria-describedby='validation-async-company_name'
                                        />
                                    )}
                                />
                                {errors.company_name && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-company_name'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='company_name_eng'
                                    control={control}
                                    rules={{ required: true }}                                    
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='회사명(영문)'
                                            id='company_name_eng'
                                            onChange={onChange}
                                            placeholder='회사명(영문)을 입력해주세요'
                                            error={Boolean(errors.company_name_eng)}
                                            aria-describedby='validation-async-company_name_eng'
                                        />
                                    )}
                                />
                                {errors.company_name_eng && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-company_name_eng'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='ceo'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='대표자명'
                                            id='ceo'
                                            onChange={onChange}
                                            placeholder='대표자명를 입력해주세요'
                                            error={Boolean(errors.ceo)}
                                            aria-describedby='validation-async-ceo'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.ceo && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-ceo'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='license_num'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='사업자등록번호'
                                            id='license_num'
                                            onChange={onChange}
                                            placeholder='사업자등록번호를 입력해주세요'
                                            error={Boolean(errors.license_num)}
                                            aria-describedby='validation-async-license_num'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.license_num && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-license_num'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <Controller
                                    name='sales_license'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='통신판매업신고'
                                            id='sales_license'
                                            onChange={onChange}
                                            placeholder='통신판매업신고 등록번호를 입력해주세요'
                                            error={Boolean(errors.sales_license)}
                                            aria-describedby='validation-async-license_num'
                                        />
                                    )}
                                />
                                {errors.sales_license && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-sales_license'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <Controller
                                    name='tel'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='대표연락처'
                                            id='tel'
                                            onChange={onChange}
                                            placeholder='대표연락처를 입력해주세요'
                                            error={Boolean(errors.tel)}
                                            aria-describedby='validation-async-tel'
                                        />
                                    )}
                                />
                                {errors.tel && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-tel'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <Controller
                                    name='fax'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='FAX번호'
                                            id='fax'
                                            onChange={onChange}
                                            placeholder='FAX번호를 입력해주세요'
                                            error={Boolean(errors.fax)}
                                            aria-describedby='validation-async-fax'
                                        />
                                    )}
                                />
                                {errors.fax && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-fax'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth>
                                <Controller
                                    name='zip'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='우편번호'
                                            id='zip'
                                            onChange={onChange}
                                            placeholder='우편번호를 입력해주세요'
                                            error={Boolean(errors.zip)}
                                            aria-describedby='validation-async-zip'
                                        />
                                    )}
                                />
                                {errors.zip && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-zip'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={9}>
                            <FormControl fullWidth>
                                <Controller
                                    name='address'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='주소'
                                            id='address'
                                            onChange={onChange}
                                            placeholder='주소를 입력해주세요'
                                            error={Boolean(errors.address)}
                                            aria-describedby='validation-async-address'
                                        />
                                    )}
                                />
                                {errors.address && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-address'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <Controller
                                    name='coo'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value || ''}
                                            label='정보관리 책임자명'
                                            id='coo'
                                            onChange={onChange}
                                            placeholder='책임자명를 입력해주세요'
                                            error={Boolean(errors.coo)}
                                            aria-describedby='validation-async-coo'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.coo && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-coo'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <Controller
                                    name='coo_email'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            type='email'
                                            value={value || ''}
                                            label='정보책임자 e-mail'
                                            id='coo_email'
                                            onChange={onChange}
                                            placeholder='정보책임자 e-mail를 입력해주세요'
                                            error={Boolean(errors.coo_email)}
                                            aria-describedby='validation-async-coo_email'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.coo_email && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-coo_email'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <Controller
                                    name='cs_email'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            type='email'
                                            value={value || ''}
                                            label='CS 이메일'
                                            id='cs_email'
                                            onChange={onChange}
                                            placeholder='CS 이메일을 입력해주세요'
                                            error={Boolean(errors.coo_email)}
                                            aria-describedby='validation-async-cs_email'
                                            variant="standard"
                                        />
                                    )}
                                />
                                {errors.cs_email && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-cs_email'>
                                        필수
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sx={{ pt: theme => `${theme.spacing(7)} !important` }}>
                            <Button type="submit" form="mallbizform" variant='contained' sx={{ mr: 4 }}>
                                수정
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}

export default SectionInfo
